// セリフ再生用の Audio 要素をアプリ全体で1つだけ持つ。
//
// なぜ使い回すのか:
//   モバイル（特に iOS Safari）は、Audio 要素ごとに「ユーザー操作の中で
//   play() されたことがあるか」を見ている。操作の外で新しく作った要素を
//   play() しても NotAllowedError で拒否される。
//
//   BGM が鳴るのに音声だけ鳴らなかったのはこれが理由。
//   BGM はボタンのクリックハンドラの中で生成・再生していたので許可され、
//   セリフの音声は行ごとに新しい要素を作ってタイマーから再生していたため
//   ずっと拒否されていた（拒否は catch していたので、無音のまま会話だけ進んでいた）。
//
// 対策:
//   「おしゃべりを始める」ボタンの中で unlock() を呼び、1つの要素を解錠しておく。
//   以降はその要素の src を差し替えて再生する。要素は同じなので許可が続く。

let el = null;
let unlocked = false;

/** 無音の短い WAV。解錠のためだけに一度鳴らす */
const SILENT_WAV =
  'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAgD4AAAB9AAACABAAZGF0YQAAAAA=';

/** アプリ全体で共有する Audio 要素を返す */
export function getPlayer() {
  if (!el) {
    el = new Audio();
    el.preload = 'auto';
    // iOS でインライン再生させる（全画面プレイヤーに奪われないように）
    el.setAttribute('playsinline', '');
  }
  return el;
}

/**
 * ユーザー操作の中から呼ぶこと。
 * ここで一度 play() しておかないと、以降タイマーからの再生が拒否される。
 */
export function unlockPlayer() {
  if (unlocked) return;
  const audio = getPlayer();
  try {
    audio.src = SILENT_WAV;
    const p = audio.play();
    if (p && typeof p.then === 'function') {
      p.then(() => {
        audio.pause();
        audio.currentTime = 0;
        unlocked = true;
      }).catch(() => {
        // 解錠に失敗しても、無音フォールバックで会話は進むので致命的ではない
      });
    } else {
      audio.pause();
      unlocked = true;
    }
  } catch {
    // 何もしない
  }
}

export function isUnlocked() {
  return unlocked;
}
